import { Controller } from "@hotwired/stimulus";

/*
 * A helper for changing styles when togglers are toggled.  Since the
 * toggler component allows showing or hiding other components without
 * JS, this controller is only used for toggling non-essential classes.
 *
 * @see {templates/macros/toggler.html}
 * @see {templates/macros/download_header_dropdown_button.html}
 */
export default class extends Controller {
  connect() {
    const el = this.element;
    // persist toggler state to/from sessionStorage
    if (el.dataset.persistState !== undefined) {
      if (sessionStorage.getItem(el.id)) {
        el.checked = sessionStorage.getItem(el.id) == "true";
      }
      el.addEventListener("change", () => {
        sessionStorage.setItem(el.id, el.checked.toString());
      });
    }
  }

  toggled(event) {
    for (const labelTarget of event.target.labels) {
      const addClasses = labelTarget.dataset.togglerClassAdd?.split(" ");

      if (addClasses) {
        labelTarget.classList[event.target.checked ? "add" : "remove"](
          ...addClasses,
        );
      }

      const removeClasses = labelTarget.dataset.togglerClassRemove?.split(" ");

      if (removeClasses) {
        labelTarget.classList[event.target.checked ? "remove" : "add"](
          ...removeClasses,
        );
      }
    }
  }
}
